<script setup lang="ts">
import LaunchPad from "./LaunchPad.vue";

const launchItems = [
  { text: "Templates d'interventions", icon: "mdi-wrench", route: "/intervention-templates" },
  { text: "Paramètres", icon: "mdi-cog", route: "/settings" },
  { text: "Utilisateurs", icon: "mdi-account", route: "/users" },
  { text: "Codes d'erreur", icon: "mdi-alert-box", route: "/product-diagnostic-contexts" },
  { text: "Modèles des produits", icon: "mdi-alpha-m-circle-outline", route: "/product-models" },
];
</script>

<template>
  <LaunchPad :items="launchItems" />
</template>
